var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[(_vm.title)?_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-spacer'),_c('v-card-actions',{staticClass:"py-0"},[_vm._t("actions")],2)],1):_vm._e(),_c('v-card-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }